"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.WaterSun = exports.Water = exports.WalkingRound = exports.Walking = exports.Volleyball2 = exports.Volleyball = exports.TreadmillRound = exports.Treadmill = exports.Tennis2 = exports.Tennis = exports.Swimming = exports.StretchingRound = exports.Stretching = exports.SkateboardingRound = exports.Skateboarding = exports.Skateboard = exports.RunningRound = exports.Running2 = exports.Running = exports.Rugby = exports.Ranking = exports.MeditationRound = exports.Meditation = exports.HikingRound = exports.HikingMinimalistic = exports.Hiking = exports.Golf = exports.Football = exports.DumbbellSmall = exports.Dumbbells2 = exports.Dumbbells = exports.DumbbellLargeMinimalistic = exports.DumbbellLarge = exports.Dumbbell = exports.Bowling = exports.BodyShapeMinimalistic = exports.BodyShape = exports.BicyclingRound = exports.Bicycling = exports.Basketball = exports.Balls = void 0;
var Balls_1 = require("./Balls");
__createBinding(exports, Balls_1, "default", "Balls");
var Basketball_1 = require("./Basketball");
__createBinding(exports, Basketball_1, "default", "Basketball");
var Bicycling_1 = require("./Bicycling");
__createBinding(exports, Bicycling_1, "default", "Bicycling");
var BicyclingRound_1 = require("./BicyclingRound");
__createBinding(exports, BicyclingRound_1, "default", "BicyclingRound");
var BodyShape_1 = require("./BodyShape");
__createBinding(exports, BodyShape_1, "default", "BodyShape");
var BodyShapeMinimalistic_1 = require("./BodyShapeMinimalistic");
__createBinding(exports, BodyShapeMinimalistic_1, "default", "BodyShapeMinimalistic");
var Bowling_1 = require("./Bowling");
__createBinding(exports, Bowling_1, "default", "Bowling");
var Dumbbell_1 = require("./Dumbbell");
__createBinding(exports, Dumbbell_1, "default", "Dumbbell");
var DumbbellLarge_1 = require("./DumbbellLarge");
__createBinding(exports, DumbbellLarge_1, "default", "DumbbellLarge");
var DumbbellLargeMinimalistic_1 = require("./DumbbellLargeMinimalistic");
__createBinding(exports, DumbbellLargeMinimalistic_1, "default", "DumbbellLargeMinimalistic");
var Dumbbells_1 = require("./Dumbbells");
__createBinding(exports, Dumbbells_1, "default", "Dumbbells");
var Dumbbells2_1 = require("./Dumbbells2");
__createBinding(exports, Dumbbells2_1, "default", "Dumbbells2");
var DumbbellSmall_1 = require("./DumbbellSmall");
__createBinding(exports, DumbbellSmall_1, "default", "DumbbellSmall");
var Football_1 = require("./Football");
__createBinding(exports, Football_1, "default", "Football");
var Golf_1 = require("./Golf");
__createBinding(exports, Golf_1, "default", "Golf");
var Hiking_1 = require("./Hiking");
__createBinding(exports, Hiking_1, "default", "Hiking");
var HikingMinimalistic_1 = require("./HikingMinimalistic");
__createBinding(exports, HikingMinimalistic_1, "default", "HikingMinimalistic");
var HikingRound_1 = require("./HikingRound");
__createBinding(exports, HikingRound_1, "default", "HikingRound");
var Meditation_1 = require("./Meditation");
__createBinding(exports, Meditation_1, "default", "Meditation");
var MeditationRound_1 = require("./MeditationRound");
__createBinding(exports, MeditationRound_1, "default", "MeditationRound");
var Ranking_1 = require("./Ranking");
__createBinding(exports, Ranking_1, "default", "Ranking");
var Rugby_1 = require("./Rugby");
__createBinding(exports, Rugby_1, "default", "Rugby");
var Running_1 = require("./Running");
__createBinding(exports, Running_1, "default", "Running");
var Running2_1 = require("./Running2");
__createBinding(exports, Running2_1, "default", "Running2");
var RunningRound_1 = require("./RunningRound");
__createBinding(exports, RunningRound_1, "default", "RunningRound");
var Skateboard_1 = require("./Skateboard");
__createBinding(exports, Skateboard_1, "default", "Skateboard");
var Skateboarding_1 = require("./Skateboarding");
__createBinding(exports, Skateboarding_1, "default", "Skateboarding");
var SkateboardingRound_1 = require("./SkateboardingRound");
__createBinding(exports, SkateboardingRound_1, "default", "SkateboardingRound");
var Stretching_1 = require("./Stretching");
__createBinding(exports, Stretching_1, "default", "Stretching");
var StretchingRound_1 = require("./StretchingRound");
__createBinding(exports, StretchingRound_1, "default", "StretchingRound");
var Swimming_1 = require("./Swimming");
__createBinding(exports, Swimming_1, "default", "Swimming");
var Tennis_1 = require("./Tennis");
__createBinding(exports, Tennis_1, "default", "Tennis");
var Tennis2_1 = require("./Tennis2");
__createBinding(exports, Tennis2_1, "default", "Tennis2");
var Treadmill_1 = require("./Treadmill");
__createBinding(exports, Treadmill_1, "default", "Treadmill");
var TreadmillRound_1 = require("./TreadmillRound");
__createBinding(exports, TreadmillRound_1, "default", "TreadmillRound");
var Volleyball_1 = require("./Volleyball");
__createBinding(exports, Volleyball_1, "default", "Volleyball");
var Volleyball2_1 = require("./Volleyball2");
__createBinding(exports, Volleyball2_1, "default", "Volleyball2");
var Walking_1 = require("./Walking");
__createBinding(exports, Walking_1, "default", "Walking");
var WalkingRound_1 = require("./WalkingRound");
__createBinding(exports, WalkingRound_1, "default", "WalkingRound");
var Water_1 = require("./Water");
__createBinding(exports, Water_1, "default", "Water");
var WaterSun_1 = require("./WaterSun");
__createBinding(exports, WaterSun_1, "default", "WaterSun");
